/**
 * @file    CopyToClipboard.jsx
 *          exports a component for copying account numbers to user clipboard
 * @author  Arnab Sagar <arnab@kingsds.network>
 * @author  Maneesh Wijewardhana <maneesh@kingsds.network>
 * @date    August 2022
 */

import { useState } from 'react';

import { Tooltip } from './Tooltip';

const { VITE_ASSETS_PATH } = import.meta.env;

/**
 * Renders a button that copies given text to the user's clipboard.
 *
 * @param   {object}      props          Component properties.
 * @param   {string}      props.copyText The text to copy.
 * @returns {JSX.Element}                The rendered component.
 */
export function CopyToClipboard({ copyText, className = '' })
{
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  async function handleClickToCopy()
  {
    await navigator.clipboard.writeText(copyText);
    setIsTooltipOpen(true);
    setTimeout(() => setIsTooltipOpen(false), 1000);
  }

  return (
    <div style={{display: 'inline-block'}} className={className}>
      <button
        className='copyToClipboard'
        title='Copy to clipboard'
        onClick={handleClickToCopy}
      >
        <img onMouseOut={() => setTimeout(() => setIsTooltipOpen(false), 150)} src={`${VITE_ASSETS_PATH}/img/copy.png`} alt='Copy to clipboard icon.' />
      </button>
      <Tooltip side='right' content='Copied' open={isTooltipOpen}/>
    </div>
  );
}
